export default defineNuxtPlugin(async nuxtApp => {
  const { initialize } = useUser()

  if (!nuxtApp.$initialized) {
    await initialize()
    nuxtApp.$initialized = true
  }
})
